import React from "react";
import { motion } from "framer-motion";

export default function StampBadge({ className = "" }) {
  return (
    <motion.div
      className={`relative select-none ${className}`}
      animate={{ rotate: 360 }}
      transition={{ repeat: Infinity, duration: 26, ease: "linear" }}
      data-testid="hero-stamp-badge"
    >
      <svg viewBox="0 0 200 200" className="w-full h-full">
        <defs>
          <path id="badgeCircle" d="M100,100 m-72,0 a72,72 0 1,1 144,0 a72,72 0 1,1 -144,0" />
        </defs>
        <circle cx="100" cy="100" r="94" fill="none" stroke="#0C0C0C" strokeWidth="3" />
        <circle cx="100" cy="100" r="82" fill="none" stroke="#0C0C0C" strokeWidth="1.5" />
        <text fill="#0C0C0C" fontSize="17" fontWeight="800" letterSpacing="5"
          style={{ fontFamily: "Barlow Condensed, sans-serif", textTransform: "uppercase" }}>
          <textPath href="#badgeCircle" startOffset="0%">
            FOGGIA · TAKE AWAY · STREET FOOD · FOGGIA · TAKE AWAY ·
          </textPath>
        </text>
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="font-display font-black text-5xl text-[#0C0C0C]">U</span>
      </div>
    </motion.div>
  );
}
